export class RemoveEventQuestionPhotoRequest{
  EventID: number = -1;
  AuditResultID: number = -1;
  AuditResultDetailID: number = -1;
  PhotoGUID: string = '';
  constructor(values: Object = {}){
    Object.assign(this, values);
  }
}
